module.exports = __webpack_public_path__ + "static/FranklinGothic-Book-e130d119682ecb567748343bf7f263b0.ttf";